import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {registerConfirmedBooking, requestApi} from "../utils/utils";
import {getTripById} from "../redux/actions/tripActions";
import {setStep} from "../redux/actions/stepActions";
import {Button, Container, Grid, Paper} from "@mui/material";
import Confirmation from "../components/Booking/Confirmation/Confirmation";
import Itinerary from "../components/Booking/Summary/Itinerary";
// import BookingStepper from "../components/Booking/BookingStepper";
import {getActivitiesByTrip} from "../redux/actions/activitiesActions";
import {setTotals} from "../redux/actions/totalActions";
import {useIsAuthenticated} from "react-auth-kit";
import GuestBar from "../components/GuestInfo/GuestBar";
import {TripPropTypes} from "../utils/PropTypes/TripPropTypes";

const ConfirmationPage = () => {

    const prefix = window['siteUrl'];
    const confirmationBanner = prefix + '/images/confirmation/banner.jpg';
    const {bookingId} = useParams();
    const {data: trip} = useSelector(state => state.trip);
    // const step = useSelector(state => state.step);
    const dispatch = useDispatch();
    const [booking, setBooking] = useState({});
    const isAuth = useIsAuthenticated();

    // const history = useHistory();


	const goBack = () => {
        history.push(`/booking/${bookingId}/information`);
    };

    async function getBooking() {
        const {data} = await requestApi(`/booking/get/${bookingId}`);
        if ('status' in data && data['status'] === 'success') {
            if (Object.keys(data['booking']).length > 0) {
                setBooking(data['booking']);
                if (trip?.TripId !== parseInt(data['booking']['TripId']))
                    dispatch(getTripById(data['booking']['TripId']));
            }
        }
    }

    useEffect(() => {
        // const stepNum = getStepFromUrl(history.location.pathname);
        const stepNum = 7;
        dispatch(setStep(stepNum));
        if (Object.keys(booking).length === 0)
            getBooking().catch();
		registerConfirmedBooking();
    }, []);

    useEffect(() => {
        if (trip?.TripId) {
            dispatch(getActivitiesByTrip(trip.TripId))
                .then(() => {
                    dispatch(setTotals());
                });
        }
    }, [trip?.TripId]);

    return (
        <div>
            {isAuth() && <GuestBar/>}
            <Container maxWidth="lg">
                {/*<BookingStepper/>*/}
                <div style={{marginTop: 50}}/>
                <div style={{
                    backgroundImage: `url("${confirmationBanner}")`,
                    backgroundPositionY: 'center',
                    marginBottom: 50
                }} className={'confirmationBanner'}/>
                {booking && Object.keys(booking).length > 0  && (
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={9}>
                            <Confirmation booking={booking}/>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3}>
                            {trip && Object.keys(trip).length > 0 && <Itinerary removable={false}/>}
                            <Paper>
                                <Button color={'primary'} variant={'contained'} fullWidth
                                        href={`${window['siteUrl']}booking/my-bookings`}>
                                    Go to my bookings
                                </Button>
                            </Paper>
                        </Grid>
                    </Grid>
                	)
				}
            </Container>
        </div>
    );
};

export default ConfirmationPage;

ConfirmationPage.propTypes = {
    trip: TripPropTypes,
}